import { useState, useEffect } from 'react';
export function useDevice() {
    var _a = useState(), isTouch = _a[0], setIsTouch = _a[1];
    var _b = useState(), isPhone = _b[0], setIsPhone = _b[1];
    var _c = useState(), isIpad = _c[0], setIsIpad = _c[1];
    useEffect(function () {
        var mediaIsTouch = window.matchMedia('(max-width: 1180px)');
        var mediaIsPhone = window.matchMedia('(max-width: 1023px)');
        var listener = function () {
            var isPhone = mediaIsPhone.matches;
            setIsTouch(mediaIsTouch.matches);
            setIsPhone(isPhone);
            setIsIpad(!isPhone);
        };
        listener();
        window.addEventListener('resize', listener);
        return function () { return window.removeEventListener('resize', listener); };
    }, []);
    return {
        isTouch: isTouch,
        isPhone: isPhone,
        isIpad: isIpad,
        classes: {
            touch: isTouch,
            phone: isPhone,
            ipad: isIpad,
        },
    };
}
